export function loadTurntable(tid) {
  return {
    type: 'LOAD_TURNTABLE',
    tid,
  };
}

export function loadTurntableCompletion(tid, error, data) {
  return {
    type: 'LOAD_TURNTABLE_COMPLETION',
    tid,
    error,
    data,
  };
}

export function loadTurntableWinners(tid) {
  return {
    type: 'LOAD_TURNTABLE_WINNERS',
    tid,
  };
}

export function loadTurntableWinnersCompletion(tid, error, data) {
  return {
    type: 'LOAD_TURNTABLE_WINNERS_COMPLETION',
    tid,
    error,
    data,
  };
}

export function lotteryTurntable(tid) {
  return {
    type: 'LOTTERY_TURNTABLE',
    tid,
  };
}

export function lotteryTurntableCompletion(tid, error, data) {
  return {
    type: 'LOTTERY_TURNTABLE_COMPLETION',
    tid,
    error,
    data,
  };
}

export function insertTurntableAwardUser(tid, awardUser) {
  return {
    type: 'INSERT_TURNTABLE_AWRADUSER',
    tid,
    awardUser,
  };
}

export function loadTurntableCount(tid) {
  return {
    type: 'LOAD_TURNTABLE_COUNT',
    tid,
  }
}

export function loadTurntableCountCompletion(tid, error, data) {
  return {
    type: 'LOAD_TURNTABLE_COUNT_COMPLETION',
    tid,
    error,
    data,
  }
}
